<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Novo Projeto</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
                <template v-slot:extension>
                    <v-tabs v-model="tabActive" color="secondary">
                        <v-tab style="width: 150px"><div style="width: 100% ; display: flex ; align-items: center ; justify-content: space-around"><span>Geral</span><info/></div></v-tab>
                        <v-tab :disabled="item.id == 0" style="width: 150px"><div style="width: 100% ; display: flex ; align-items: center ; justify-content: space-around"><span>Beneficiário</span><info/></div></v-tab>
                        <v-tab :disabled="item.id == 0" style="width: 150px"><div style="width: 100% ; display: flex ; align-items: center ; justify-content: space-around"><span>Atividades</span><info/></div></v-tab>
                        <v-tab :disabled="item.id == 0" style="width: 220px"><div style="width: 100% ; display: flex ; align-items: center ; justify-content: space-around"><span>Recurso Pessoal</span><info/></div></v-tab>
                    </v-tabs>
                </template>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formCadastroProjeto" ref="formCadastroProjeto" v-model="valid" lazy-validation >

                    <v-tabs-items v-model="tabActive">

                        <v-tab-item>
                            <v-row>
                                <v-col cols="12" md="1">
                                    <v-text-field v-model="item.id" label="Código" readonly dense outlined/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="item.nome" label="Nome" :rules="fieldRules" :counter="80" maxlength="80" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                        <template v-slot:activator="{on}">
                                            <v-text-field type="date" v-model="item.dataInicio" label="Data Inicial" :rules="fieldRules" dense outlined>
                                                <template v-slot:prepend>
                                                    <v-icon v-on="on">mdi-calendar</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker locale="pt-br" v-model="item.dataInicio" no-title/>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                        <template v-slot:activator="{on}">
                                            <v-text-field type="date" v-model="item.dataTermino" label="Data Termino" dense outlined>
                                                <template v-slot:prepend>
                                                    <v-icon v-on="on">mdi-calendar</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker locale="pt-br" v-model="item.dataTermino" no-title/>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-select v-model="item.aberto" label="Aberto" :items="abertos" item-value="key" item-text="value" dense outlined/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="2" sm="3">
                                    <v-text-field type="number" v-model="item.metaBeneficiario" label="Meta Beneficiário" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="3" sm="3">
                                    <v-select v-model="item.tipoProjetoId" label="Tipo" :items="tipoProjetos" item-value="id" item-text="nome" :rules="fieldRules" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="3" sm="3">
                                    <v-select v-model="item.restricaoRecursos" label="Restrição dos Recursos" :items="restricoesRecursos" item-value="value" item-text="text" :rules="fieldRules" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="4" sm="3">
                                    <v-text-field v-model="item.cnpjFinanciador" label="CNPJ Financiador" v-mask="mskCnpj" counter="18" maxlength="18" @blur="item.cnpjFinanciador = (item.cnpjFinanciador || '').toLocaleUpperCase()" dense outlined/>
                                </v-col>
                            </v-row>
                            <fieldset class="px-4">
                                <legend>Frequência</legend>

                                <v-row>
                                    <v-col cols="12" md="3" sm="4">
                                        <v-select v-model="item.frequenciaTipo" class="mt-4" label="Tipo" :items="tipoFrequencias" hide-details item-value="key" item-text="value" dense outlined/>
                                    </v-col>
                                    <v-col cols="4" md="1" sm="2">
                                        <v-checkbox v-model="item.frequenciaSegunda" label="Segunda" dense outlined/>
                                    </v-col>
                                    <v-col cols="4" md="1" sm="2">
                                        <v-checkbox v-model="item.frequenciaTerca" label="Terça" dense outlined/>
                                    </v-col>
                                    <v-col cols="4" md="1" sm="2">
                                        <v-checkbox v-model="item.frequenciaQuarta" label="Quarta" dense outlined/>
                                    </v-col>
                                    <v-col cols="4" md="1" sm="2">
                                        <v-checkbox v-model="item.frequenciaQuinta" label="Quinta" dense outlined/>
                                    </v-col>
                                    <v-col cols="4" md="1" sm="2">
                                        <v-checkbox v-model="item.frequenciaSexta" label="Sexta" dense outlined/>
                                    </v-col>
                                    <v-col cols="4" md="1" sm="2">
                                        <v-checkbox v-model="item.frequenciaSabado" label="Sábado" dense outlined/>
                                    </v-col>
                                    <v-col cols="4" md="1" sm="2">
                                        <v-checkbox v-model="item.frequenciaDomingo" label="Domingo" dense outlined/>
                                    </v-col>
                                </v-row>
                            </fieldset>
                            <v-row class="mt-3">
                                <v-col cols="12" md="12">
                                    <v-textarea v-model="item.objetivo" label="Objetivo" :counter="2000" maxlength="2000" dense outlined/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                        <template v-slot:activator="{on}">
                                            <v-text-field type="date" v-model="dataReplicar" label="Replicar o projeto para a data inicial abaixo" dense outlined>
                                                <template v-slot:prepend>
                                                    <v-icon v-on="on">mdi-calendar</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker locale="pt-br" v-model="dataReplicar" no-title/>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="1">
                                    <v-btn color="primary" @click="Replicar()">Replicar</v-btn>
                                </v-col>
                            </v-row>
                        </v-tab-item>
                        <!-- BENEFICIARIO -->
                        <v-tab-item>
                            <v-data-table  class="elevation-1" :headers="headerBeneficiario" :items="item.beneficiarios" :items-per-page="-1" hide-default-footer>
                                
                                <template v-slot:top>
                                    <v-toolbar flat>
                                        <v-spacer></v-spacer>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                            <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="AbrirDialogBeneficiario(0)">
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                            </template>
                                            <span>Novo Beneficiário</span>
                                        </v-tooltip>
                                    </v-toolbar>
                                </template>

                                <template v-slot:[`item.actions`]="{ item }">

                                    <v-tooltip right>
                                        <template v-slot:activator="{ on }">
                                            <v-icon small @click="EditarBeneficiario(item)" v-on="on">mdi-pencil</v-icon>
                                        </template>
                                        <span>Editar</span>
                                    </v-tooltip>
                                    <v-tooltip right>
                                        <template v-slot:activator="{ on }">
                                            <v-icon small @click="ExcluirBeneficiario(item)" v-on="on">mdi-delete</v-icon>
                                        </template>
                                        <span>Excluir</span>
                                    </v-tooltip>

                                </template>

                                <template v-slot:[`item.dataEntrada`]="{ item }">
                                    {{new Date(item.dataEntrada).ddmmyyyy()}}
                                </template>

                                <template v-slot:[`item.dataSaida`]="{ item }">
                                    {{item.dataSaida ? new Date(item.dataSaida).ddmmyyyy() : ''}}
                                </template>

                            </v-data-table>
                        </v-tab-item>
                        <!-- ATIVIDADES -->
                        <v-tab-item>

                            <v-data-table class="elevation-1" :headers="headerAtividade" :items="item.atividades" item-key="id" :expanded="item.atividades" show-expand :items-per-page="-1" hide-default-footer>
            
                                <template v-slot:top>
                                    <v-toolbar flat>
                                        <v-spacer></v-spacer>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                            <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="AbrirDialogAtividade({id: 0})">
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                            </template>
                                            <span>Nova Atividade</span>
                                        </v-tooltip>
                                    </v-toolbar>
                                </template>
                                
                                <template v-slot:[`item.actions`]="{ item }">

                                    <v-tooltip right>
                                        <template v-slot:activator="{ on }">
                                        <v-icon small @click="AbrirDialogAtividade(item)" v-on="on">mdi-plus-circle</v-icon>
                                        </template>
                                        <span>Nova SubAtividade</span>
                                    </v-tooltip>
                                    <v-tooltip right>
                                        <template v-slot:activator="{ on }">
                                        <v-icon small @click="EditarAtividade(item)" v-on="on">mdi-pencil</v-icon>
                                        </template>
                                        <span>Editar</span>
                                    </v-tooltip>
                                    <v-tooltip right>
                                        <template v-slot:activator="{ on }">
                                        <v-icon small @click="ExcluirAtividade(item)" v-on="on">mdi-delete</v-icon>
                                        </template>
                                        <span>Excluir</span>
                                    </v-tooltip>

                                </template>

                                <template v-slot:[`item.dataInicio`]="{ item }">
                                    {{new Date(item.dataInicio).ddmmyyyy()}}
                                </template>

                                <template v-slot:[`item.dataTermino`]="{ item }">
                                    {{item.dataTermino ? new Date(item.dataTermino).ddmmyyyy() : ''}}
                                </template>

                                <template v-slot:[`item.custoEstimado`]="{ item }">
                                    {{item.custoEstimado.toMoeda(true)}}
                                </template>

                                <template v-slot:expanded-item="{ item }">
                                    <td colspan="7" class="pa-0">
                                        <v-data-table class="expandDataTable" :headers="headerAtividade" :items="item.itens" item-key="id" :items-per-page="-1" hide-default-footer>
                                            
                                            <template v-slot:[`item.actions`]="{ item }">
                                                <div style="margin-left: 5vw ; margin-right: -2vw ; width: 80%">
                                                    <v-tooltip right>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon small @click="EditarAtividadeItem(item)" v-on="on">mdi-pencil</v-icon>
                                                        </template>
                                                        <span>Editar</span>
                                                    </v-tooltip>
                                                    <v-tooltip right>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon small @click="ExcluirAtividadeItem(item)" v-on="on">mdi-delete</v-icon>
                                                        </template>
                                                        <span>Excluir</span>
                                                    </v-tooltip>
                                                </div>
                                            </template>
                                            
                                            <template v-slot:[`item.id`]="{ item }">
                                                <div style="margin-right: 2.5vw">
                                                    {{item.id}}
                                                </div>
                                            </template>

                                            <template v-slot:[`item.nome`]="{ item }">
                                                <div style="margin-right: 1.5vw ; margin-left: -1.5vw">
                                                    {{item.nome}}
                                                </div>
                                            </template>
                                            
                                            <template v-slot:[`item.dataInicio`]="{ item }">
                                                <div>
                                                    {{new Date(item.dataInicio).ddmmyyyy()}}
                                                </div>
                                            </template>

                                            <template v-slot:[`item.dataTermino`]="{ item }">
                                                <div>
                                                    {{item.dataTermino ? new Date(item.dataTermino).ddmmyyyy() : ''}}
                                                </div>
                                            </template>

                                            <template v-slot:[`item.custoEstimado`]="{ item }">
                                                <div>
                                                    {{item.custoEstimado.toMoeda(true)}}
                                                </div>
                                            </template>

                                        </v-data-table>
                                    </td>
                                </template>

                            </v-data-table>

                            <!-- <v-data-table
                                :headers="headerAtividade"
                                :items="item.atividades"
                                item-key="id"
                                class="elevation-1">
                                <template v-slot:top>
                                    <v-toolbar flat>
                                        <v-spacer></v-spacer>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                            <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="AbrirDialogAtividade(0)">
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                            </template>
                                            <span>Nova Atividade</span>
                                        </v-tooltip>
                                    </v-toolbar>
                                </template>
                                <template v-slot:item="{ item, expand, isExpanded }">

                                    <tr>
                                        <td class="text-right px-0" style="width: 5%"> 
                                            
                                            <v-tooltip right>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon small @click="expand(!isExpanded)" color="primary" v-on="on">{{isExpanded ? 'mdi-arrow-up-circle' : 'mdi-arrow-down-circle'}}</v-icon>
                                                </template>
                                                <span>Expandir</span>
                                            </v-tooltip>
                                            <v-tooltip right>
                                                <template v-slot:activator="{ on }">
                                                <v-icon small @click="AbrirDialogAtividade(item.id)" v-on="on">mdi-plus-circle</v-icon>
                                                </template>
                                                <span>Nova SubAtividade</span>
                                            </v-tooltip>
                                            <v-tooltip right>
                                                <template v-slot:activator="{ on }">
                                                <v-icon small @click="EditarAtividade(item)" v-on="on">mdi-pencil</v-icon>
                                                </template>
                                                <span>Editar</span>
                                            </v-tooltip>
                                            <v-tooltip right>
                                                <template v-slot:activator="{ on }">
                                                <v-icon small @click="ExcluirAtividade(item)" v-on="on">mdi-delete</v-icon>
                                                </template>
                                                <span>Excluir</span>
                                            </v-tooltip>
                                        </td>
                                        <td style="width: 5%">{{ item.id }}</td>
                                        <td style="width: 30%">{{ item.nome }}</td>
                                        <td style="width: 10%">{{ new Date(item.dataInicio).ddmmyyyy() }}</td>
                                        <td style="width: 10%">{{ item.dataTermino ? new Date(item.dataTermino).ddmmyyyy() : '' }}</td>
                                        <td style="width: 10%" class="text-right">{{ item.custoEstimado.toMoeda(true) }}</td>
                                    </tr>
                                    
                                </template>
                                <template v-slot:expanded-item="{ headers, item }">
                                    <td :colspan="headers.length" class="blue-grey lighten-5">
                                        <table>
                                            <tr v-for="subAtividade in item.itens" :key="subAtividade.id">
                                                <td  class="text-right px-0" style="width: 5%">
                                                    <v-tooltip right>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon small @click="EditarAtividadeItem(subAtividade)" v-on="on">mdi-pencil</v-icon>
                                                    </template>
                                                    <span>Editar</span>
                                                    </v-tooltip>
                                                    <v-tooltip right>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon small @click="ExcluirAtividadeItem(subAtividade)" v-on="on">mdi-delete</v-icon>
                                                    </template>
                                                    <span>Excluir</span>
                                                    </v-tooltip>
                                                </td>
                                                <td style="width: 9%">{{ subAtividade.id }}</td>
                                                <td style="width: 43%">{{ subAtividade.nome }}</td>
                                                <td style="width: 12%">{{ subAtividade.dataInicio ? new Date(subAtividade.dataInicio).ddmmyyyy() : '' }}</td>
                                                <td style="width: 10%">{{ subAtividade.dataTermino ? new Date(subAtividade.dataTermino).ddmmyyyy() : '' }}</td>
                                                <td style="width: 15%" class="text-right">{{ subAtividade.custoEstimado.toMoeda(true) }}</td>
                                            </tr>
                                        </table>
                                    </td>
                                </template>
                            </v-data-table> -->

                        </v-tab-item>
                        <!-- RECURSO PESSOAL -->
                        <v-tab-item>
                            <v-data-table :headers="headerPessoal" :items="item.pessoais" class="elevation-1" :items-per-page="-1" hide-default-footer>
            
                                <template v-slot:top>
                                    <v-toolbar flat>
                                        <v-spacer></v-spacer>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                            <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="AbrirDialogPessoal(0)">
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                            </template>
                                            <span>Novo Recurso Pessoal</span>
                                        </v-tooltip>
                                    </v-toolbar>
                                </template>
                                
                                <template v-slot:[`item.actions`]="{ item }">

                                    <v-tooltip right>
                                        <template v-slot:activator="{ on }">
                                        <v-icon small @click="ExcluirPessoal(item)" v-on="on">mdi-delete</v-icon>
                                        </template>
                                        <span>Excluir</span>
                                    </v-tooltip>

                                </template>

                                <template v-slot:[`item.pessoal.tipoRegime`]="{ item }">
                                    {{item.pessoal.tipoRegimeStr}}
                                </template>

                            </v-data-table>
                        </v-tab-item>

                    </v-tabs-items>

                </v-form>
            </v-card-text>
        </v-card>

        <v-dialog v-model="dialogAtividade" width="800" persistent>
            <v-form id="formCadastroAtividade" ref="formCadastroAtividade" v-model="validAtividade" lazy-validation>
                <v-card>
                    <v-card-title class="headline primary white--text">{{ atividadeId > 0 ? 'Atividade Item' : 'Atividade'}}</v-card-title>
                    <v-card-text class="mt-5">
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-text-field label="Nome" v-model="atividade.nome" :rules="fieldRules" :counter="255" maxlength="255" dense outlined/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                    <template v-slot:activator="{on}">
                                        <v-text-field type="date" v-model="atividade.dataInicio" label="Data Início" :rules="fieldRules" dense outlined>
                                            <template v-slot:prepend>
                                                <v-icon v-on="on">mdi-calendar</v-icon>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker locale="pt-br" v-model="atividade.dataInicio" no-title/>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                    <template v-slot:activator="{on}">
                                        <v-text-field type="date" v-model="atividade.dataTermino" label="Data Término" dense outlined>
                                            <template v-slot:prepend>
                                                <v-icon v-on="on">mdi-calendar</v-icon>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker locale="pt-br" v-model="atividade.dataTermino" no-title/>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field type="number" v-model.number="atividade.custoEstimado" label="Custo Estimado" :disabled="atividadeId == 0" dense outlined/>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secundary" text @click="dialogAtividade = false; atividadeId = 0" :loading="salvando">Fechar</v-btn>
                        <v-btn color="primary" text :disabled="!validAtividade" @click="atividadeId > 0 ? SalvarAtividadeItem() : SalvarAtividade()" :loading="salvando">Salvar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog v-model="dialogBeneficiario" width="800" persistent>
            <v-form id="formCadastroBeneficiario" ref="formCadastroBeneficiario" v-model="validBeneficiario" lazy-validation>
                <v-card>
                    <v-card-title class="headline primary white--text">Beneficiário</v-card-title>
                    <v-card-text class="mt-5">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-autocomplete v-model="beneficiario.beneficiarioId" :items="beneficiarios" :loading="isLoading" :search-input.sync="searchBeneficiario" hide-no-data hide-selected cache-items
                                    item-text="nome" :rules="fieldRules" item-value="id" label="Beneficiario" :placeholder="beneficiario.projetoId == 0 ? 'Digite o beneficiário' : beneficiario.beneficiario.nome" :disabled="beneficiario.projetoId > 0" dense outlined>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                    <template v-slot:activator="{on}">
                                        <v-text-field type="date" v-model="beneficiario.dataEntrada" label="Data Entrada" :rules="fieldRules" :disabled="beneficiario.projetoId > 0" dense outlined>
                                            <template v-slot:prepend>
                                                <v-icon v-on="on">mdi-calendar</v-icon>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker locale="pt-br" v-model="beneficiario.dataEntrada" no-title/>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                    <template v-slot:activator="{on}">
                                        <v-text-field type="date" v-model="beneficiario.dataSaida" label="Data Saída" :disabled="beneficiario.projetoId == 0" dense outlined>
                                            <template v-slot:prepend>
                                                <v-icon v-on="on">mdi-calendar</v-icon>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker locale="pt-br" v-model="beneficiario.dataSaida" no-title/>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secundary" text @click="dialogBeneficiario = false" :loading="salvando">Fechar</v-btn>
                        <v-btn color="primary" text :disabled="!validBeneficiario" @click="SalvarBeneficiario()" :loading="salvando">Salvar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog v-model="dialogPessoal" width="800">
            <v-form id="formPessoal" ref="formPessoal" v-model="validPessoal" lazy-validation >
                <v-card>
                    <v-card-title class="headline primary white--text">Pessoal</v-card-title>
                    <v-card-text class="mt-5">
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-autocomplete v-model="pessoal.pessoalId" :items="pessoais" :loading="isLoading" :search-input.sync="searchPessoal" hide-no-data hide-selected cache-items
                                    item-text="nome" :rules="fieldRules" item-value="id" label="Recurso Pessoal" placeholder="Digite o Recurso Pessoal" dense outlined>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secundary" text @click="dialogPessoal = false" :loading="salvando">Fechar</v-btn>
                        <v-btn color="primary" text @click="SalvarPessoal()" :disabled="!validPessoal" :loading="salvando">Salvar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import { MskCnpjAlfa } from '@/core/domain/shared/Global';
import {ProjetoService, TipoProjetoService, BeneficiarioService, PessoalService} from '@/core/services/projetos';
import {SimNaoEnumService, TipoFrequenciaEnumService} from '@/core/services/geral';
import {Projeto, ProjetoBeneficiario, ProjetoPessoal, Atividade, AtividadeItem} from '@/core/domain/projetos';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function(value) { 
            if ('formCadastroProjeto' in this.$refs)
                this.$refs.formCadastroProjeto.resetValidation();

            value.beneficiarios.map(function(beneficiario, index) {
                return beneficiario.dataSaida ? index : -1;
            }).filter(function(index) {
                return index >= 0;
            }).reverse().forEach(function(index) {
                value.beneficiarios.splice(index,1);
            });

        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
        },
        searchBeneficiario (val) {
            if (this.isLoading) return;
            if (!val) return;

            this.isLoading = true
            this.beneficiarioService.AutoComplete(val)
                .then(
                    res => {
                        this.beneficiarios = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isLoading = false))
        },
        searchPessoal (val) {
            if (this.isLoading) return;
            if (!val) return;

            this.isLoading = true
            this.pessoalService.AutoComplete(val)
                .then(
                    res => {
                        this.pessoais = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isLoading = false))
        },
    },
    data: () => ({
        service: new ProjetoService(),
        beneficiarioService: new BeneficiarioService(),
        pessoalService: new PessoalService(),
        beneficiario: new ProjetoBeneficiario(),
        pessoal: new ProjetoPessoal(),
        mskCnpj: MskCnpjAlfa,
        dataReplicar: '',
        tabActive: null,
        searchBeneficiario: null,
        searchPessoal: null,
        valid: true,
        validAtividade: true,
        validPessoal: true,
        validBeneficiario: true,
        dialog: false,
        dialogAtividade: false,
        dialogBeneficiario: false,
        dialogPessoal: false,
        beneficiarioId: 0,
        pessoalId: 0,
        atividadeId: 0,
        isLoading: false,
        expanded: [],
        tipoProjetos: [],
        restricoesRecursos: [
            { value: 'L', text: 'Livre' },
            { value: 'R', text: 'Restrito' }
        ],
        abertos: [],
        tipoFrequencias: [],
        beneficiarios: [],
        pessoais: [],
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        atividade: new Atividade(),
        atividadeItem: new AtividadeItem(),
        headerBeneficiario: [
            { text: '', value: 'actions', sortable: false  },
            { text: 'Código', value: 'beneficiarioId', type: 'number' },
            { text: 'Nome', value: 'beneficiario.nome' },
            { text: 'Entrada', value: 'dataEntrada' },
            { text: 'Saída', value: 'dataSaida' }
        ],
        headerAtividade: [
            { text: '', value: 'actions', sortable: false },
            { text: 'Código', value: 'id', type: 'number' },
            { text: 'Nome', value: 'nome' },
            { text: 'Início', value: 'dataInicio' },
            { text: 'Término', value: 'dataTermino' },
            { text: 'Total Estimado', value: 'custoEstimado' }
        ],
        headerPessoal: [
            { text: '', value: 'actions', sortable: false  },
            { text: 'Código', value: 'pessoalId', type: 'number' },
            { text: 'Nome', value: 'pessoal.nome' },
            { text: 'Cargo', value: 'pessoal.cargo' },
            { text: 'Tipo', value: 'pessoal.tipoRegime' }
        ],        
        sessionApp: {},
        salvando: false
    }),
    methods: {
        Replicar(){
            this.salvando = true;
            this.service.Replicar(this.item.id, this.dataReplicar).then(
                res => {
                    this.$swal('Aviso', 'Projeto replicado com sucesso!', 'success');
                    this.$emit('salvou');
                    this.close();
                },
                err => {
                    this.$swal('Aviso', err.response.data, 'error');
                }
            ).finally(() => {
                this.salvando = false;
            });
        },
        EditarAtividade(item){
            this.atividade = new Atividade(item);
            this.dialogAtividade = true;
        },
        EditarBeneficiario(item){
            this.beneficiario = new ProjetoBeneficiario(item);
            this.dialogBeneficiario = true;
        },
        ExcluirBeneficiario(item) {
            this.$swal({
              title: 'Atenção!',
              text: 'Tem certeza que deseja excluir o beneficiário atual?',
              type: 'question',
              showCancelButton: true,
              confirmButtonText: 'Sim',
              cancelButtonText: 'Não',
              showCloseButton: true,
              showLoaderOnConfirm: true,
              preConfirm: () => {
                  return this.service.ExcluirBeneficiario(item.projetoId, item.beneficiarioId)
                          .then(res => {
                              if (res.status == 200){
                                  return res;
                              }
                          }, 
                          err => this.$swal('Aviso', err.response.data, 'error')
                      )
                  },
              allowOutsideClick: () => !this.$swal.isLoading()
              })
              .then((result) => {
                  if(result.value) {
                    this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
                    const index = this.item.beneficiarios.indexOf(item);
                    this.item.beneficiarios.splice(index, 1);
                  }
              })
        },
        ExcluirPessoal(item) {
            this.$swal({
                title: 'Atenção!',
                text: 'Tem certeza que deseja excluir o recurso pessoal atual?',
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.service.ExcluirPessoal(item.projetoId, item.pessoalId).then(
                        res => {
                            if (res.status == 200){
                                return res;
                            }
                        }, 
                        err => this.$swal('Aviso', err.response.data, 'error')
                    )
                },
                allowOutsideClick: () => !this.$swal.isLoading()
                })
                .then((result) => {
                    if(result.value) {
                    this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
                    const index = this.item.pessoais.indexOf(item);
                    this.item.pessoais.splice(index, 1);
                    }
                })
        },
        ExcluirAtividade(item) {
            this.$swal({
                title: 'Atenção!',
                text: 'Tem certeza que deseja excluir a atividade atual?',
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.service.ExcluirAtividade(item.projetoId, item.id).then(
                        res => {
                            if (res.status == 200){
                                return res;
                            }
                        }, 
                        err => this.$swal('Aviso', err.response.data, 'error')
                    )
                },
                allowOutsideClick: () => !this.$swal.isLoading()
                })
                .then((result) => {
                    if(result.value) {
                        this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
                        const index = this.item.atividades.indexOf(item);
                        this.item.atividades.splice(index, 1);
                    }
                })
        },
        EditarAtividadeItem(item){
            this.atividade = new AtividadeItem(item);
            this.atividadeId = item.atividadeId;
            this.dialogAtividade = true;
        },
        ExcluirAtividadeItem(item) {
            this.$swal({
              title: 'Atenção!',
              text: 'Tem certeza que deseja excluir a subatividade atual?',
              type: 'question',
              showCancelButton: true,
              confirmButtonText: 'Sim',
              cancelButtonText: 'Não',
              showCloseButton: true,
              showLoaderOnConfirm: true,
              preConfirm: () => {
                  return this.service.ExcluirAtividadeItem(item.projetoId, item.atividadeId, item.id)
                          .then(res => {
                              if (res.status == 200){
                                  return res;
                              }
                          }, 
                          err => this.$swal('Aviso', err.response.data, 'error')
                      )
                  },
              allowOutsideClick: () => !this.$swal.isLoading()
              })
              .then((result) => {
                  if(result.value) {
                    this.$swal('Aviso', 'SubAtividade excluida com sucesso!', result.value.status == 200 ? 'success' : 'warning');
                    this.item.atividades = result.value.data;
                    //this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
                    // let atividade = this.item.atividades.find(x => x.id == item.atividadeId);
                    // const index = atividade.itens.indexOf(item);
                    // atividade.itens.splice(index, 1);
                  }
              })
        },
        AbrirDialogBeneficiario(beneficiarioId){
            if ('formCadastroBeneficiario' in this.$refs)
                this.$refs.formCadastroBeneficiario.resetValidation();

            this.beneficiarioId = beneficiarioId;
            this.dialogBeneficiario = true;
        },
        AbrirDialogPessoal(pessoalId){
            if ('formPessoal' in this.$refs)
                this.$refs.formPessoal.resetValidation();

            this.pessoalId = pessoalId;
            this.dialogPessoal = true;
        },
        AbrirDialogAtividade(atividade){
            if ('formCadastroAtividade' in this.$refs)
                this.$refs.formCadastroAtividade.resetValidation();

            this.atividadeId = atividade.id;
            this.atividade = new Atividade();
            this.atividade.dataInicio = atividade.dataInicio ? new Date(atividade.dataInicio).yyyymmdd() : '';
            this.atividade.dataTermino =  atividade.dataTermino ? new Date(atividade.dataTermino).yyyymmdd() : '';
            this.dialogAtividade = true;
        },
        SalvarBeneficiario(){
            if (this.$refs.formCadastroBeneficiario.validate()) {
                this.salvando = true;
                if (this.beneficiario.projetoId > 0){
                    this.service.AlterarBeneficiario(this.item.id, this.beneficiario.beneficiarioId, this.beneficiario)
                    .then(res => {
                        this.item.beneficiarios = res.data;
                    },
                    err => {
                        this.$swal('Aviso', err.response.data, 'error');
                    })
                    .finally(() => {
                        this.beneficiario = new ProjetoBeneficiario();
                        this.dialogBeneficiario = false;
                        this.salvando = false;
                    });
                }
                else {
                    this.service.IncluirBeneficiario(this.item.id, this.beneficiario)
                    .then(res => {
                        this.item.beneficiarios.push(res.data);
                    },
                    err => {
                        this.$swal('Aviso', err.response.data, 'error');
                    })
                    .finally(() => {
                        this.beneficiario = new ProjetoBeneficiario();
                        this.dialogBeneficiario = false;
                        this.salvando = false;
                    });
                }
            }
        },
        SalvarPessoal(){

            if (this.$refs.formPessoal.validate()) {
                
                if(this.item.pessoais.some(x => x.pessoalId == this.pessoal.pessoalId)){
                    this.$swal('Aviso', "Recursso pessoal já se encontra vinculado ao projeto.", 'warning');
                }
                else{
                    this.salvando = true;
                    this.service.IncluirPessoal(this.item.id, this.pessoal).then(
                        res => {
                            this.item.pessoais.push(res.data);
                        },
                        err => {
                            this.$swal('Aviso', err.response.data, 'error');
                        }
                    ).finally(() => {
                        this.pessoal = new ProjetoPessoal();
                        this.dialogPessoal = false;
                        this.salvando = false;
                    });
                }
            }

        },
        SalvarAtividade(){

            if (this.$refs.formCadastroAtividade.validate()) {
                this.salvando = true;
                if (this.atividade.id > 0){
                    this.service.AlterarAtividade(this.item.id, this.atividade.id, this.atividade)
                    .then(res => {
                        this.item.atividades = res.data;
                        this.dialogAtividade = false;
                        this.atividade = new Atividade();
                    },
                    err => {
                        this.$swal('Aviso', err.response.data, 'error');
                    })
                    .finally(() => {
                        this.salvando = false;
                    });
                }
                else {
                    this.service.IncluirAtividade(this.item.id, this.atividade)
                    .then(res => {
                        this.item.atividades.push(res.data);
                        this.dialogAtividade = false;
                        this.atividade = new Atividade();
                    },
                    err => {
                        this.$swal('Aviso', err.response.data, 'error');
                    })
                    .finally(() => {
                        this.salvando = false;
                    });
                }
            }
        },
        SalvarAtividadeItem(){
            if (this.$refs.formCadastroAtividade.validate()) {
                this.salvando = true;
                if (this.atividade.id > 0){
                    this.service.AlterarAtividadeItem(this.item.id, this.atividade.atividadeId, this.atividade.id, this.atividade).then(
                            res => {
                            this.item.atividades = res.data;
                            this.dialogAtividade = false;
                            this.atividade = new Atividade();
                        },
                        err => {
                            this.$swal('Aviso', err.response.data, 'error');
                        }
                    ).finally(() => {
                        this.salvando = false;
                    });
                }
                else {
                    this.service.IncluirAtividadeItem(this.item.id, this.atividadeId, this.atividade).then(
                        res => {
                            // let atividade = this.item.atividades.find(x => x.id == this.atividadeId);
                            // atividade.itens.push(res.data);
                            this.item.atividades = res.data;
                            this.dialogAtividade = false;
                            this.atividade = new Atividade();
                        },
                        err => {
                            this.$swal('Aviso', err.response.data, 'error');
                        }
                    ).finally(() => {
                        this.salvando = false;
                    });
                }
            }
        },
        save() {

            if (this.$refs.formCadastroProjeto.validate()) {

                this.item.metaBeneficiario = this.item.metaBeneficiario.length == 0 ? 0 : this.item.metaBeneficiario;

                this.salvando = true;

                let modelo = new Projeto(this.item);

                this.service.Salvar(modelo).then(
                    res => {
                        this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.$emit('salvou');
                        this.close();

                    }, 
                        err =>  {
                            if (err.response.status == 400) {
                                this.$swal('Aviso', err.response.data.title || err.response.data, 'warning')
                        }
                        else {
                            this.$swal('Aviso', err.response.data, 'error')
                        }
                    }
                ).finally(() => {
                    this.salvando = false;
                })
            }

        },
        close() {
            this.dialog = false;
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {

        let tipoProjetoService = new TipoProjetoService();
        tipoProjetoService.Listar()
            .then(
                res => {
                    this.tipoProjetos = res.data.items;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

        let simNaoEnumService = new SimNaoEnumService();
        simNaoEnumService.Listar()
            .then(
                res => {
                    this.abertos = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

        let tipoFrequenciaEnumService = new TipoFrequenciaEnumService();
        tipoFrequenciaEnumService.Listar()
            .then(
                res => {
                    this.tipoFrequencias = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );
    }
}
</script>
